import { Action } from 'redux';

import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { SelectSortOrder } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface SelectSortOrderAction extends Action {
  readonly order: ReadonlyArray<IOrderClause>;
}

export function selectSortOrder(order: ReadonlyArray<IOrderClause>): SelectSortOrderAction {
  return {
    type: SelectSortOrder,
    order
  };
}

export const isSelectSortOrderAction = isActionFactory<SelectSortOrderAction>(SelectSortOrder);
